/* esm.sh - d3-transition@3.0.1/src/selection/transition */
export * from "/*d3-transition@3.0.1/esnext/src/selection/transition.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/selection/transition.mjs";
